const getBeerStylesFilterQuery = (checkedBeerStyles: string[]) => {
  let filterQuery = '';

  checkedBeerStyles.forEach((beerStyle) => {
    filterQuery += `&filter[beer_style][]=${beerStyle}`;
  });

  return filterQuery;
};

export default getBeerStylesFilterQuery;
